import React from "react";

import AboutUs from "../pages/Company/AboutUs/AboutUs";
import Faqs from "../pages/Company/Faqs/Faqs";

import JobDetails from "../pages/Jobs/JobDetails/JobDetails";
import JobList from "../pages/Jobs/JobList/JobList";
import JobsCategories from "../pages/Jobs/JobsCategories/JobsCategories";

import CandidateGrid from "../pages/CandidateAndCompany/CandidateGrid/CandidateGrid";
import CompanyDetails from "../pages/CandidateAndCompany/CompanyDetails/CompanyDetails";
import CompanyList from "../pages/CandidateAndCompany/CompanyList/CompanyList";

import Blog from "../pages/Blog/Blog/Blog";
import BlogAuther from "../pages/Blog/BlogAuther/BlogAuther";
import BlogDetails from "../pages/Blog/BlogDetails/BlogDetails";

import Contact from "../pages/Contact/Contact";

import ComingSoon from "../pages/ExtraPages/ComingSoon";
import Error404 from "../pages/ExtraPages/Error404";
import ForgotPassword from "../pages/ExtraPages/ForgotPassword";
import ResetPassword from "../pages/ExtraPages/ResetPassword";
import SignIn from "../pages/ExtraPages/SignIn";
import SignOut from "../pages/ExtraPages/SignOut";
import SignUp from "../pages/ExtraPages/SignUp";

import MyApplications from "../pages/Profile/ManageJobs/MyApplications";
import MyProfile from "../pages/Profile/MyProfile/MyProfile";

const Layout1 = React.lazy(() => import("../pages/Home/Layout1/Layout1"));

// Rotas públicas (acessíveis sem autenticação)
const publicRoutes = [
  { path: "/", component: <Layout1 /> },

  { path: "/aboutus", component: <AboutUs /> },
  { path: "/faqs", component: <Faqs /> },

  { path: "/jobscategories", component: <JobsCategories /> },
  { path: "/jobdetails/:id", component: <JobDetails /> },
  { path: "/joblist", component: <JobList /> },

  { path: "/companydetails/:id", component: <CompanyDetails /> },
  { path: "/companylist", component: <CompanyList /> },
  { path: "/candidategrid", component: <CandidateGrid /> },

  { path: "/blog", component: <Blog /> },
  { path: "/blogauther", component: <BlogAuther /> },
  { path: "/blogdetails/:id", component: <BlogDetails /> },

  { path: "/contact", component: <Contact /> },

  // Components
  // { path: "/components", component: <Components /> },

  // Error pages
  // { path: "/unauthorized", component: <Unauthorized /> },
  { path: "*", component: <Error404 /> },
];

// Rotas protegidas (requerem autenticação)
const protectedRoutes = [
  { path: "/myprofile", component: <MyProfile /> },
  { path: "/myapplications", component: <MyApplications /> },
];

// Rotas de autenticação (acesso apenas quando NÃO autenticado)
const authRoutes = [
  { path: "/signin", component: <SignIn /> },
  { path: "/signup", component: <SignUp /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/comingsoon", component: <ComingSoon /> },
  { path: "/signout", component: <SignOut /> },
];

const userRoutes = [...publicRoutes, ...protectedRoutes];

export { authRoutes, publicRoutes, protectedRoutes, userRoutes };
